/**
 * Normalizes HELIX_API_URL for URL construction. Returns null when unset or invalid.
 */
export function normalizeApiBaseUrl(apiBaseUrl: unknown): string | null {
  if (apiBaseUrl == null || apiBaseUrl === '') {
    return null;
  }

  const trimmed = String(apiBaseUrl).trim();

  if (!trimmed) {
    return null;
  }

  return trimmed.replace(/\/$/, '');
}

/**
 * Returns the origin of the configured API base URL, or null when unavailable.
 * Relative bases (e.g. `/api/v2`) resolve against `window.location.origin` in the browser.
 */
export function resolveApiOrigin(apiBaseUrl: unknown): string | null {
  const normalized = normalizeApiBaseUrl(apiBaseUrl);

  if (!normalized) {
    return null;
  }

  try {
    return new URL(normalized).origin;
  } catch {
    if (normalized.startsWith('/') && typeof window !== 'undefined' && window.location?.origin) {
      try {
        return new URL(normalized, window.location.origin).origin;
      } catch {
        return null;
      }
    }

    return null;
  }
}

export function getHelixApiBaseUrl(apiUrl?: unknown): string | null {
  const envUrl =
    apiUrl ??
    (typeof import.meta !== 'undefined'
      ? (import.meta as ImportMeta & { env?: { HELIX_API_URL?: string } }).env?.HELIX_API_URL
      : undefined);

  return normalizeApiBaseUrl(envUrl);
}
